"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Accordion = _interopRequireDefault(require("01_core/components/layout/Accordion"));
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CSwitch = _interopRequireDefault(require("01_core/components/materials/CSwitch"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _KansaTgtJigyoBasicInfo = _interopRequireDefault(require("../../common/components/materials/KansaTgtJigyoBasicInfo"));
var _kansaResultActions = require("../kansaResultActions");
var _ShitekiJiko = _interopRequireDefault(require("./components/ShitekiJiko"));
var Yup = _interopRequireWildcard(require("yup"));
var _useRHFForm = require("01_core/validation/useRHFForm");
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const StyledReturnButton = (0, _styles.styled)(_CButton.default)({
  margin: '0 0 0 auto'
});
const StyledBlockSpace = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(1)
  };
});
function ShitekiKaizenplanJissekiEntry(props) {
  const {
    intl,
    callAPI,
    kansaInfo,
    shitekiList,
    shitekiEntriesList,
    setShitekiList,
    setShitekiEntries,
    setContent,
    setKansaTgtJigyoBasicInfo,
    mailFlg,
    gyomuCd,
    pushSwitchFlg,
    pushFlg,
    changePusSwitchFlg,
    changePushFlg,
    setMailErrMsg,
    openConfirm,
    openInfoBar,
    setDirty,
    btnProps,
    kansaTgtJigyoBasicInfo
  } = props;
  const didInitValuesRef = (0, _react.useRef)(false);
  const [loaded, setLoaded] = _react.default.useState(false);
  const getKey = (0, _react.useCallback)(item => item.shitekijikoKbnCd + item.no, []);
  (0, _react.useEffect)(() => {
    changePushFlg(true);
    setLoaded(false);
    callAPI(_APIs.KANSA_RESULT_SHITEKI_REGISTER_DISP, kansaInfo).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        setShitekiList(response.data.shitekiList);
        changePusSwitchFlg(mailFlg && gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_2 && response.data.hikansabumonChiefHyokaStsCd === _CodeConsts.CODE.KANSA_HYOKA_STS.CODE_3);
      } else {
        setShitekiList([]);
      }
    }).catch(e => {
      if ((e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED || (e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.CALLING) {
        return;
      }
      throw e;
    }).finally(() => {
      setLoaded(true);
    });
    callAPI(_APIs.KANSA_TGT_JIGYO_BASIC, kansaInfo).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        setKansaTgtJigyoBasicInfo(response.data);
      }
    }).catch(e => {
      if ((e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED || (e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.CALLING) {
        return;
      }
      throw e;
    });
  }, [changePushFlg, callAPI, kansaInfo, setShitekiList, changePusSwitchFlg, mailFlg, gyomuCd, setKansaTgtJigyoBasicInfo]);
  const createDefaultValues = (0, _react.useCallback)(() => {
    const dv = {};
    Object.values(shitekiEntriesList || {}).forEach(item => {
      var _item$taisaku, _item$hikansabumonTan, _item$planningCompYot, _item$planningShoninD, _item$planningShonins, _item$taiocompCompDat, _item$taiocompCompSho, _item$taiocompCompSho2;
      const key = item.shitekijikoKbnCd + item.no;
      dv["".concat(key, "_taisaku")] = (_item$taisaku = item.taisaku) !== null && _item$taisaku !== void 0 ? _item$taisaku : '';
      dv["".concat(key, "_hikansabumonTantoshaNm")] = (_item$hikansabumonTan = item.hikansabumonTantoshaNm) !== null && _item$hikansabumonTan !== void 0 ? _item$hikansabumonTan : '';
      dv["".concat(key, "_planningCompYoteiDate")] = (_item$planningCompYot = item.planningCompYoteiDate) !== null && _item$planningCompYot !== void 0 ? _item$planningCompYot : '';
      dv["".concat(key, "_planningShoninDate")] = (_item$planningShoninD = item.planningShoninDate) !== null && _item$planningShoninD !== void 0 ? _item$planningShoninD : '';
      dv["".concat(key, "_planningShoninshaNm")] = (_item$planningShonins = item.planningShoninshaNm) !== null && _item$planningShonins !== void 0 ? _item$planningShonins : '';
      dv["".concat(key, "_taiocompCompDate")] = (_item$taiocompCompDat = item.taiocompCompDate) !== null && _item$taiocompCompDat !== void 0 ? _item$taiocompCompDat : '';
      dv["".concat(key, "_taiocompCompShoninDate")] = (_item$taiocompCompSho = item.taiocompCompShoninDate) !== null && _item$taiocompCompSho !== void 0 ? _item$taiocompCompSho : '';
      dv["".concat(key, "_taiocompCompShoninshaNm")] = (_item$taiocompCompSho2 = item.taiocompCompShoninshaNm) !== null && _item$taiocompCompSho2 !== void 0 ? _item$taiocompCompSho2 : '';
    });
    return dv;
  }, [shitekiEntriesList]);
  const shape = (0, _react.useMemo)(() => {
    const baseDate = Yup.string().concat((0, _validationHelpers.dateOrEmptyStrict)(intl)).concat((0, _validationHelpers.notFutureDateOrEmpty)(intl));
    const s = {};
    Object.values(shitekiEntriesList || {}).forEach(item => {
      const key = item.shitekijikoKbnCd + item.no;
      s["".concat(key, "_taisaku")] = (0, _validationHelpers.requiredStringTrimMaxWhen)(intl, ["".concat(key, "_taiocompCompShoninDate"), "".concat(key, "_taiocompCompShoninshaNm")], (d, n) => !!(d && d.trim() !== '') || !!(n && n.trim() !== ''), 500);
      s["".concat(key, "_hikansabumonTantoshaNm")] = (0, _validationHelpers.requiredStringTrimMaxWhen)(intl, ["".concat(key, "_taiocompCompShoninDate"), "".concat(key, "_taiocompCompShoninshaNm")], (d, n) => !!(d && d.trim() !== '') || !!(n && n.trim() !== ''), 64);
      s["".concat(key, "_planningCompYoteiDate")] = (0, _validationHelpers.requiredWhen)(intl, ["".concat(key, "_planningShoninDate"), "".concat(key, "_planningShoninshaNm"), "".concat(key, "_taiocompCompShoninDate"), "".concat(key, "_taiocompCompShoninshaNm")], (pd, pn, td, tn) => !!(pd && pd.trim() !== '') || !!(pn && pn.trim() !== '') || !!(td && td.trim() !== '') || !!(tn && tn.trim() !== ''), baseDate);
      s["".concat(key, "_planningShoninDate")] = baseDate.test('required-planningShoninDate', intl.formatMessage({
        id: _labelConsts.LABEL.CORE_PLEASE_SELECT
      }), function (v) {
        var _this$parent, _this$parent2, _this$parent3;
        const pn = (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent["".concat(key, "_planningShoninshaNm")];
        const td = (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : _this$parent2["".concat(key, "_taiocompCompShoninDate")];
        const tn = (_this$parent3 = this.parent) === null || _this$parent3 === void 0 ? void 0 : _this$parent3["".concat(key, "_taiocompCompShoninshaNm")];
        const required = !!(pn && pn.trim() !== '') || !!(td && td.trim() !== '') || !!(tn && tn.trim() !== '');
        if (!required) return true;
        return !!(v && v !== '' && v !== 'invalid');
      });
      s["".concat(key, "_planningShoninshaNm")] = (0, _validationHelpers.requiredStringTrimMaxWhen)(intl, ["".concat(key, "_planningShoninDate"), "".concat(key, "_taiocompCompShoninDate"), "".concat(key, "_taiocompCompShoninshaNm")], (pd, td, tn) => !!(pd && pd.trim() !== '') || !!(td && td.trim() !== '') || !!(tn && tn.trim() !== ''), 64);
      s["".concat(key, "_taiocompCompDate")] = (0, _validationHelpers.requiredWhen)(intl, ["".concat(key, "_taiocompCompShoninDate"), "".concat(key, "_taiocompCompShoninshaNm")], (d, n) => !!(d && d.trim() !== '') || !!(n && n.trim() !== ''), baseDate);
      s["".concat(key, "_taiocompCompShoninDate")] = baseDate.test('required-taiocompCompShoninDate', intl.formatMessage({
        id: _labelConsts.LABEL.CORE_PLEASE_SELECT
      }), function (v) {
        var _this$parent4;
        const n = (_this$parent4 = this.parent) === null || _this$parent4 === void 0 ? void 0 : _this$parent4["".concat(key, "_taiocompCompShoninshaNm")];
        const required = !!(n && n.trim() !== '');
        if (!required) return true;
        return !!(v && v !== '' && v !== 'invalid');
      });
      s["".concat(key, "_taiocompCompShoninshaNm")] = (0, _validationHelpers.requiredStringTrimMaxWhen)(intl, ["".concat(key, "_taiocompCompShoninDate")], d => !!(d && d.trim() !== ''), 64);
    });
    return s;
  }, [shitekiEntriesList, intl]);
  const {
    handleSubmit,
    setValue,
    formState,
    reset
  } = (0, _useRHFForm.useRHFForm)({
    defaultValues: createDefaultValues(),
    shape
  });
  const {
    errors
  } = formState;
  (0, _react.useEffect)(() => {
    if (!didInitValuesRef.current && shitekiEntriesList && Object.keys(shitekiEntriesList).length > 0) {
      reset(createDefaultValues());
      didInitValuesRef.current = true;
    }
  }, [shitekiEntriesList, reset, createDefaultValues]);
  (0, _react.useEffect)(() => {
    Object.values(shitekiEntriesList || {}).forEach(item => {
      var _item$taisaku2, _item$hikansabumonTan2, _item$planningCompYot2, _item$planningShoninD2, _item$planningShonins2, _item$taiocompCompDat2, _item$taiocompCompSho3, _item$taiocompCompSho4;
      const key = item.shitekijikoKbnCd + item.no;
      setValue("".concat(key, "_taisaku"), (_item$taisaku2 = item.taisaku) !== null && _item$taisaku2 !== void 0 ? _item$taisaku2 : '', {
        shouldValidate: false,
        shouldDirty: false
      });
      setValue("".concat(key, "_hikansabumonTantoshaNm"), (_item$hikansabumonTan2 = item.hikansabumonTantoshaNm) !== null && _item$hikansabumonTan2 !== void 0 ? _item$hikansabumonTan2 : '', {
        shouldValidate: false,
        shouldDirty: false
      });
      setValue("".concat(key, "_planningCompYoteiDate"), (_item$planningCompYot2 = item.planningCompYoteiDate) !== null && _item$planningCompYot2 !== void 0 ? _item$planningCompYot2 : '', {
        shouldValidate: false,
        shouldDirty: false
      });
      setValue("".concat(key, "_planningShoninDate"), (_item$planningShoninD2 = item.planningShoninDate) !== null && _item$planningShoninD2 !== void 0 ? _item$planningShoninD2 : '', {
        shouldValidate: false,
        shouldDirty: false
      });
      setValue("".concat(key, "_planningShoninshaNm"), (_item$planningShonins2 = item.planningShoninshaNm) !== null && _item$planningShonins2 !== void 0 ? _item$planningShonins2 : '', {
        shouldValidate: false,
        shouldDirty: false
      });
      setValue("".concat(key, "_taiocompCompDate"), (_item$taiocompCompDat2 = item.taiocompCompDate) !== null && _item$taiocompCompDat2 !== void 0 ? _item$taiocompCompDat2 : '', {
        shouldValidate: false,
        shouldDirty: false
      });
      setValue("".concat(key, "_taiocompCompShoninDate"), (_item$taiocompCompSho3 = item.taiocompCompShoninDate) !== null && _item$taiocompCompSho3 !== void 0 ? _item$taiocompCompSho3 : '', {
        shouldValidate: false,
        shouldDirty: false
      });
      setValue("".concat(key, "_taiocompCompShoninshaNm"), (_item$taiocompCompSho4 = item.taiocompCompShoninshaNm) !== null && _item$taiocompCompSho4 !== void 0 ? _item$taiocompCompSho4 : '', {
        shouldValidate: false,
        shouldDirty: false
      });
    });
  }, [shitekiEntriesList, setValue]);
  const setEntry = (0, _react.useCallback)((key, entryKey) => value => {
    setShitekiEntries(key, entryKey)(value);
    setDirty(true);
    setValue("".concat(key, "_").concat(entryKey), value, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [setShitekiEntries, setDirty, setValue]);
  const checkPlanSts = (0, _react.useCallback)(registerData => {
    let kaizenplanSakuseizumiCnt = 0;
    let kaizenPlanComp = false;
    registerData.forEach(item => {
      if (item.planningShoninDate && item.planningShoninshaNm) {
        kaizenplanSakuseizumiCnt++;
      }
    });
    kaizenPlanComp = kaizenplanSakuseizumiCnt === registerData.length;
    return kaizenPlanComp;
  }, []);
  const onRegister = (0, _react.useCallback)((registerData, kaizenPlanComp) => {
    const newPushFlg = pushSwitchFlg && pushFlg && kaizenPlanComp;
    callAPI(_APIs.KANSA_RESULT_SHITEKI_REGISTER, {
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
      items: registerData,
      pushFlg: newPushFlg
    }).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        setDirty(false);
        setMailErrMsg(response.message);
        setContent(_kansaResultActions.CONTENTS.SHITEKI_RESULT);
      }
    });
  }, [callAPI, kansaInfo, pushSwitchFlg, pushFlg, setDirty, setMailErrMsg, setContent]);
  const onValid = (0, _react.useCallback)(() => {
    const entryList = shitekiEntriesList || {};
    let registerData = [];
    for (let key in entryList) {
      registerData.push(_objectSpread({}, entryList[key]));
    }
    const kaizenPlanComp = checkPlanSts(registerData);
    let message = '';
    if (pushSwitchFlg && pushFlg) {
      if (kaizenPlanComp) {
        message = intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_SEND_MAIL_CONFIRM
        }, {
          0: intl.formatMessage({
            id: _labelConsts.LABEL.KANSA_KANSA_BUMON
          })
        });
      } else {
        message = intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_SEND_MAIL_CONFIRM_SHITEKI_NO_PLAN
        });
      }
    }
    openConfirm(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CONFIRM
    }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
      id: _labelConsts.LABEL.CORE_REGISTER_CONFIRM_MESSAGE
    }), message), () => onRegister(registerData, kaizenPlanComp));
  }, [shitekiEntriesList, pushSwitchFlg, pushFlg, intl, openConfirm, checkPlanSts, onRegister]);
  const onInvalid = (0, _react.useCallback)(() => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  }, [openInfoBar, intl]);
  const returnButton = /*#__PURE__*/_react.default.createElement(StyledReturnButton, {
    onClick: btnProps.onClick(false),
    autoWidth: true,
    negative: true
  }, btnProps.label);
  const getErrorsForKey = (0, _react.useCallback)(key => {
    var _errors, _errors2, _errors3, _errors4, _errors5, _errors6, _errors7, _errors8;
    return {
      taisaku: (_errors = errors["".concat(key, "_taisaku")]) === null || _errors === void 0 ? void 0 : _errors.message,
      hikansabumonTantoshaNm: (_errors2 = errors["".concat(key, "_hikansabumonTantoshaNm")]) === null || _errors2 === void 0 ? void 0 : _errors2.message,
      planningCompYoteiDate: (_errors3 = errors["".concat(key, "_planningCompYoteiDate")]) === null || _errors3 === void 0 ? void 0 : _errors3.message,
      planningShoninDate: (_errors4 = errors["".concat(key, "_planningShoninDate")]) === null || _errors4 === void 0 ? void 0 : _errors4.message,
      planningShoninshaNm: (_errors5 = errors["".concat(key, "_planningShoninshaNm")]) === null || _errors5 === void 0 ? void 0 : _errors5.message,
      taiocompCompDate: (_errors6 = errors["".concat(key, "_taiocompCompDate")]) === null || _errors6 === void 0 ? void 0 : _errors6.message,
      taiocompCompShoninDate: (_errors7 = errors["".concat(key, "_taiocompCompShoninDate")]) === null || _errors7 === void 0 ? void 0 : _errors7.message,
      taiocompCompShoninshaNm: (_errors8 = errors["".concat(key, "_taiocompCompShoninshaNm")]) === null || _errors8 === void 0 ? void 0 : _errors8.message
    };
  }, [errors]);
  return /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(onValid, onInvalid)
  }, /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_KAIZENPLAN_ZISSEKI_REGISTER
    }),
    actions: [returnButton, shitekiList.length === 0 ? null : /*#__PURE__*/_react.default.createElement(_CButton.default, {
      autoWidth: true,
      submit: true,
      key: "register"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_REGISTER
    }))]
  }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, !loaded ? null : shitekiList.length === 0 ?
  /*#__PURE__*/
  // 表示する情報がない場合
  _react.default.createElement(_material.Typography, null, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_NO_SHITEKI_KAIZENPLAN_ZISSEKI
  })) : /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true
  }, returnButton, /*#__PURE__*/_react.default.createElement(_KansaTgtJigyoBasicInfo.default, {
    data: kansaTgtJigyoBasicInfo
  }), shitekiList.map((item, index) => {
    const dispIndex = index + 1;
    const key = getKey(item);
    return /*#__PURE__*/_react.default.createElement(StyledBlockSpace, {
      key: dispIndex
    }, /*#__PURE__*/_react.default.createElement(_Accordion.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_SHITEKI_JIKO
      }) + dispIndex
    }, /*#__PURE__*/_react.default.createElement(_ShitekiJiko.default, {
      shitekiJiko: item,
      mode: _kansaResultActions.CONTENTS.SHITEKI_ENTRY,
      setShitekiEntries: setEntry,
      shitekiEntriesList: shitekiEntriesList,
      kansaTgtNendoNm: kansaTgtJigyoBasicInfo.kansaTgtNendoNm,
      errors: getErrorsForKey(key)
    })));
  }), pushSwitchFlg && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 8
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_PUSH_COMPLETE_REGISTER
    }),
    required: true,
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_PUSH_MAIL
  }, {
    0: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KANSA_BUMON
    })
  }), /*#__PURE__*/_react.default.createElement(_CSwitch.default, {
    checked: pushFlg,
    onChange: changePushFlg,
    required: true,
    shiftLeft: true
  }))))))));
}
const mapStateToProps = state => ({
  kansaInfo: state.kansaResult.kansaInfo,
  shitekiList: state.kansaResult.shitekiList,
  shitekiEntriesList: state.kansaResult.shitekiEntriesList,
  mailFlg: state.coreLoginInfo.mailFlg,
  gyomuCd: state.kansaResult.searchConditions.gyomuCd,
  pushSwitchFlg: state.kansaResult.pushSwitchFlg,
  pushFlg: state.kansaResult.pushFlg,
  kansaTgtJigyoBasicInfo: state.kansaResult.kansaTgtJigyoBasicInfo
});
const mapDispatchToProps = dispatch => {
  return {
    setShitekiList: shitekiList => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_SHITEKI_LIST](shitekiList)),
    setShitekiEntries: (no, key) => value => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_SHITEKI_ENTRIES_LIST](no, key, value)),
    setContent: content => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_CONTENT](content)),
    setKansaInfo: kansaInfo => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_KANSA_INFO](kansaInfo)),
    setKansaTgtJigyoBasicInfo: kansaTgtJigyoBasicInfo => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_KANSA_TGT_JIGYO_BASIC_INFO](kansaTgtJigyoBasicInfo)),
    changePusSwitchFlg: flg => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.CHANGE_PUSH_SWITCH_FLG](flg)),
    changePushFlg: flg => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.CHANGE_PUSH_FLG](flg)),
    setMailErrMsg: mailErrMsg => {
      dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_MAIL_ERR_MSG](mailErrMsg));
    },
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    closeInfoBar: () => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.CLOSE]()),
    setDirty: dirty => dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](dirty))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)((0, _CallAPI.withCallAPI)(ShitekiKaizenplanJissekiEntry))));